import axios from 'axios';
import {
  TUserParamsSearch,
  TStaffSearch,
} from '../components/ui/UsersFilter/types';
import {
  CREATE_USER_URL,
  getUserUrl,
  SEND_INVITE_URL,
  delUserUrl,
  uploadUserAvatarUrl,
  GET_USER_LIST,
  editUserUrl,
  linkrUrl,
} from '../constants';
import { IUserAddProps, IUserEditProps } from '../interfaces/user';

export function getUsersByRole(params: TUserParamsSearch) {
  return axios.get(GET_USER_LIST, {params: {
    role: params.roles,
    page: params.page,
    size: params.size,
    sort: 'created,desc',
  }});
}

export function getSearchUsers(params: Partial<TStaffSearch>) {
  let url = `/api/users/search`;
  return axios.get(url, { params });
}

export function getUser(id: string) {
  return axios.get(getUserUrl(id));
}

export function createUser(data: IUserAddProps) {
  return axios.post(CREATE_USER_URL, data);
}

export function editUser(id: string, data: IUserEditProps) {
  return axios.put(editUserUrl(id), data);
}

export function createLink(userId: string) {
  return axios.post(linkrUrl(), { userId });
}

export function deleteUser(id: string) {
  return axios.delete(editUserUrl(id));
}

export function sendInvite(data: string) {
  return axios.get(`${SEND_INVITE_URL}?email=${data}`);
}

export function delUser(id: number) {
  return axios.delete(delUserUrl(id));
}

export function uploadUserAvatar({ photo, id }: { photo: FormData; id: string }) {
  return axios.post(uploadUserAvatarUrl(id), photo);
}

export function deleteUserPhoto(id: string) {
  return axios.delete(`/api/user/${id}/delete_photo`);
}

export function deleteMePhoto() {
  return axios.delete(`/api/me/delete_photo`);
}
export function addDeviceUser({ platform, token }: { platform: string; token: string }) {
  return axios.post(`/api/user_device/add`, { platform, token });
}
export function pushUser({
  user_id,
  platform,
  message,
}: {
  user_id: number;
  platform: string;
  message: string;
}) {
  return axios.post(
    `/api/user_device/message?user_id=${user_id}&platform=${platform}&message=${message}`
  );
}
